import { toTitleCase } from "../../../../Utils/stringUtls";

const CompanyInformation = ({ data }) => {
  const {
    ci_businessName,
    ci_physicalAddress,
    ci_mailingAddress,
    ci_companyFax,
    ci_companyPhone,
    ci_companyPhoneCountry,
    ci_companyWebURL,
    ci_otherBusinessLoc,
    ci_date_business_established,
  } = data["1_2"];
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid gap-sm" className="">
        <div
          i2c-grid="12@md"
          className="fw-700 font-bold mt-24 review-summary-sub-heading"
        >
          Company Information
        </div>
        <div i2c-grid="12">
          <div className="overview-help-text font-bold">
            Trade or Business Name
          </div>
          <div className="overview-val-text">
            {" "}
            {ci_businessName?.length ? toTitleCase(ci_businessName) : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Company Phone</div>
          <div className="overview-val-text">
            {/* <div className="fflag flag-loading country-flag fflag-PK" style={{backgroundImage: 'url(/static/dist/assets/images/flagSprite42.png)'}}></div> */}
            {ci_companyPhone?.length
              ? ci_companyPhoneCountry + " - " + ci_companyPhone
              : "-"}
          </div>
        </div>

        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Physical Address</div>
          <div className="overview-val-text">
            {ci_physicalAddress?.length ? toTitleCase(ci_physicalAddress) : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Mailing Address</div>
          <div className="overview-val-text">
            {ci_mailingAddress?.length ? toTitleCase(ci_mailingAddress) : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Company Fax</div>
          <div className="overview-val-text">
            {ci_companyFax?.length ? ci_companyFax : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Company Website URL
          </div>
          <div className="overview-val-text">
            {ci_companyWebURL?.length ? toTitleCase(ci_companyWebURL) : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Other Business Locations
          </div>
          <div className="overview-val-text">
            {ci_otherBusinessLoc?.length
              ? toTitleCase(ci_otherBusinessLoc)
              : "-"}
          </div>
        </div>

        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Date Business Established
          </div>
          <div className="overview-val-text">
            {ci_date_business_established?.length
              ? ci_date_business_established
              : "-"}
          </div>
        </div>
      </div>
    </div>
  );
};
export default CompanyInformation;
